module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', [_c('div', {
    staticClass: "container"
  }, [_c('menu', [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "button-wrap",
    attrs: {
      "tag": "div",
      "to": "/accounts"
    }
  }, [_c('a', [_vm._v("Accounts")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "button-wrap",
    attrs: {
      "tag": "div",
      "to": "/prospects"
    }
  }, [_c('a', [_vm._v("Prospects")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "button-wrap",
    attrs: {
      "tag": "div",
      "to": "/website"
    }
  }, [_c('a', [_vm._v("Website")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "button-wrap",
    attrs: {
      "tag": "div",
      "to": "/libraries"
    }
  }, [_c('a', [_vm._v("Film Database")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "button-wrap",
    attrs: {
      "tag": "div",
      "to": "/employees"
    }
  }, [_c('a', [_vm._v("Employees")])])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "bar"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ad9469e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./app/components/frame/menu.vue
// module id = 669
// module chunks = 30